import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { HistoriaDatosEntity } from 'src/app/services/servicio-historia.service';

@Component({
  selector: 'app-header-historia-cenpresabil',
  templateUrl: './header-historia-cenpresabil.component.html',
  styleUrls: ['./header-historia-cenpresabil.component.css']
})
export class HeaderHistoriaCenpresabilComponent implements OnInit, OnChanges {

  @Input() public imagenLogo : string = "";
  @Input() public objetoEntity : HistoriaDatosEntity = {
    nombre : "",
    fechaAtencion : "",
    ciudadPatronal : "",
    empresa : "",
    tipoIdentificacion : "",
    numeroIdentificacion : "",
    fechaNacimiento : "",
    sexo : "",
    direccion : "",
    ciudadNacimiento : "",
    sector : "",
    nit : "",
    medicoAtencion : "",
    descripcionMedico : "",
    registroMedico : "",
    cargo : "",
    telefonoAfiliado : "",
    ciudadAfiliado : "",
    estadoCivil : "",
    eps : "",
    arl : "",
    afp : "",
    nivelEscolar : "",
    empleador : "",
    prosefion : ""
  }

  @Input() public objetoValoracion : string = "";

  public edad : any = 0;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.getObjetoEntity();
  }

  private async getObjetoEntity() {
    try {
      await this.objetoEntity;
      await this.objetoValoracion;
      await this.imagenLogo;

      if( this.objetoEntity != null ) {

        let fechaAtencion : Date = new Date();
        let fechaNacimiento : Date = new Date();

        fechaAtencion = new Date(this.objetoEntity.fechaAtencion);
        fechaNacimiento = new Date(this.objetoEntity.fechaNacimiento);

       this.edad = fechaAtencion.getFullYear() - fechaNacimiento.getFullYear();
      }

    }catch(exception){
      console.log(exception);
    }
  }

}
